/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Your_Plan_Subscriptions_HeadingInputs */

const en_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan subscriptions`)
};

const id_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan paket Anda`)
};

const ms_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Langganan pelan anda`)
};

const ca_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les teves subscripcions`)
};

const cs_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše předplatná`)
};

const da_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dine abonnementer`)
};

const de_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Abonnements`)
};

const et_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teie plaani tellimused`)
};

const es_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus suscripciones`)
};

const fr_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vos abonnements`)
};

const hr_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše pretplate`)
};

const it_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo piano di abbonamento`)
};

const lv_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu plāna abonementi`)
};

const lt_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsų plano prenumeratos`)
};

const hu_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Ön előfizetései`)
};

const nl_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je abonnementen`)
};

const nb_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnementene dine`)
};

const pl_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje subskrypcje`)
};

const pt_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano de assinaturas`)
};

const ro_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonamentele planului tău`)
};

const sk_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše predplatné`)
};

const sl_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaše naročnine`)
};

const fi_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinun tilauksesi`)
};

const sv_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dina planabonnemang`)
};

const vi_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói đăng ký của bạn`)
};

const tr_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan abonelikleriniz`)
};

const el_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Οι συνδρομές του προγράμματός σας`)
};

const bg_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Твоите абонаменти за планове`)
};

const ru_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша подписка на план`)
};

const sr_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваши пакети претплата`)
};

const uk_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш план підписки`)
};

const ka_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`თქვენი დაგეგმილი გამოწერები`)
};

const hi_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपके प्लान सुब्स्क्रिप्शन्स`)
};

const th_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แพ็กเกจการเป็นสมาชิกของคุณ`)
};

const ko_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내 플랜 구독`)
};

const zh_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的套餐订阅`)
};

const zh_tw_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的方案訂閱`)
};

const ja_your_plan_subscriptions_heading = /** @type {(inputs: Your_Plan_Subscriptions_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご利用中のサブスクリプションプラン`)
};

/**
* | output |
* | --- |
* | "Your plan subscriptions" |
*
* @param {Your_Plan_Subscriptions_HeadingInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const your_plan_subscriptions_heading = /** @type {((inputs?: Your_Plan_Subscriptions_HeadingInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Your_Plan_Subscriptions_HeadingInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_your_plan_subscriptions_heading(inputs)
	if (locale === "ms") return ms_your_plan_subscriptions_heading(inputs)
	if (locale === "ca") return ca_your_plan_subscriptions_heading(inputs)
	if (locale === "cs") return cs_your_plan_subscriptions_heading(inputs)
	if (locale === "da") return da_your_plan_subscriptions_heading(inputs)
	if (locale === "de") return de_your_plan_subscriptions_heading(inputs)
	if (locale === "et") return et_your_plan_subscriptions_heading(inputs)
	if (locale === "es") return es_your_plan_subscriptions_heading(inputs)
	if (locale === "fr") return fr_your_plan_subscriptions_heading(inputs)
	if (locale === "hr") return hr_your_plan_subscriptions_heading(inputs)
	if (locale === "it") return it_your_plan_subscriptions_heading(inputs)
	if (locale === "lv") return lv_your_plan_subscriptions_heading(inputs)
	if (locale === "lt") return lt_your_plan_subscriptions_heading(inputs)
	if (locale === "hu") return hu_your_plan_subscriptions_heading(inputs)
	if (locale === "nl") return nl_your_plan_subscriptions_heading(inputs)
	if (locale === "nb") return nb_your_plan_subscriptions_heading(inputs)
	if (locale === "pl") return pl_your_plan_subscriptions_heading(inputs)
	if (locale === "pt") return pt_your_plan_subscriptions_heading(inputs)
	if (locale === "ro") return ro_your_plan_subscriptions_heading(inputs)
	if (locale === "sk") return sk_your_plan_subscriptions_heading(inputs)
	if (locale === "sl") return sl_your_plan_subscriptions_heading(inputs)
	if (locale === "fi") return fi_your_plan_subscriptions_heading(inputs)
	if (locale === "sv") return sv_your_plan_subscriptions_heading(inputs)
	if (locale === "vi") return vi_your_plan_subscriptions_heading(inputs)
	if (locale === "tr") return tr_your_plan_subscriptions_heading(inputs)
	if (locale === "el") return el_your_plan_subscriptions_heading(inputs)
	if (locale === "bg") return bg_your_plan_subscriptions_heading(inputs)
	if (locale === "ru") return ru_your_plan_subscriptions_heading(inputs)
	if (locale === "sr") return sr_your_plan_subscriptions_heading(inputs)
	if (locale === "uk") return uk_your_plan_subscriptions_heading(inputs)
	if (locale === "ka") return ka_your_plan_subscriptions_heading(inputs)
	if (locale === "hi") return hi_your_plan_subscriptions_heading(inputs)
	if (locale === "th") return th_your_plan_subscriptions_heading(inputs)
	if (locale === "ko") return ko_your_plan_subscriptions_heading(inputs)
	if (locale === "zh") return zh_your_plan_subscriptions_heading(inputs)
	if (locale === "zh-tw") return zh_tw_your_plan_subscriptions_heading(inputs)
	if (locale === "ja") return ja_your_plan_subscriptions_heading(inputs)
	return en_your_plan_subscriptions_heading(inputs)
});